import { db, doc, setDoc, updateDoc, arrayUnion, getDoc } from '../firebase.js'

/**
 * Loguje akcije korisnika nad lead-ovima
 * @param {string} action - "add" | "edit" | "delete"
 * @param {object} lead - lead objekat
 * @param {object} [changes] - samo za edit: { fieldName: { old: val, new: val }, ... }
 */
export async function logLeadActivity(action, lead, changes = null) {
  try {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) return;

    const user = JSON.parse(storedUser);
    const userEmail = user.email;
    if (!userEmail) return;

    const logRef = doc(db, 'logs', userEmail);

    const logSnap = await getDoc(logRef);

    const logEntry = {
      timestamp: new Date(),
      action,
      leadId: lead.id || lead.id, // Firestore id ili custom id
      leadName: lead.name,
      changes: changes || null
    };

    if (logSnap.exists()) {
      await updateDoc(logRef, {
        activities: arrayUnion(logEntry)
      });
    } else {
      await setDoc(logRef, {
        email: userEmail,
        activities: [logEntry]
      });
    }

    console.log('Lead activity logged:', logEntry);
  } catch (error) {
    console.error('Error logging lead activity:', error);
  }
}
